jQuery(function($) {

    var $icon_slider = $('.icon-wrap')
    var icon_slider_settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    prevArrow: '<div class="slick-arrow slick-prev"></div>',
    nextArrow: '<div class="slide-arrow slick-next"></div>',
    responsive: [
        {
        breakpoint: 99999,
        settings: "unslick"
        },{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
        }
        }
    ]          
    };

    // Init Slider
    $icon_slider.slick(icon_slider_settings);

    // Reslick only if it's not slick()
    $(window).on('resize', function() {
    if (!$icon_slider.hasClass('slick-initialized')) {
        return $icon_slider.slick(icon_slider_settings);
    }
    });

})